<template>
  <div class="container-fluid">
    <section class="dashboard row">
      <div class="col-12">
        <personal-invoice
          v-if="agreements.length"
          v-on:selectAgrm="selectAgrm"
          :agreementsList="agreements"
          :loading="loading.agreements"
        />
      </div>
      <div class="col-12 col-xl-6">
        <active-subscriptions
          :data="subscriptions"
          :loading="loading.subscriptions"
          v-on:subscriptionDeleted="subscriptionDeleted"
          :agrmid="selectedAgrmId"
          @refresh="fetchSubscriptions(selectedAgrmId)"
        />
      </div>
      <div class="col-12 col-xl-6">
        <statistics
          :data="statistics"
          :loading="loading.statistics"
          :agrmid="selectedAgrmId"
        />
      </div>
    </section>
  </div>
</template>

<script>
import PersonalInvoice from './PersonalInvoice'
import Statistics from './Statistics'
import ActiveSubscriptions from './ActiveSubscriptions'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'Dashboard',
  components: {
    'personal-invoice': PersonalInvoice,
    'statistics': Statistics,
    'active-subscriptions': ActiveSubscriptions
  },
  data () {
    return {
      selectedIndex: 0,
      statistics: [],
      subscriptions: [],
      loading: {
        agreements: false,
        statistics: false,
        subscriptions: false
      }
    }
  },
  computed: {
    ...mapState({
      agreements: state => state.profile.agreements
    }),
    selectedAgrmId: function() {
      return this.agreements[this.selectedIndex].id
    }
  },
  mounted () {
    this.loading.agreements = true
    this.$store.dispatch('getProfile').then((promise) => {
      this.loading.agreements = false
      this.fetchStatistics(this.selectedAgrmId)
      this.fetchSubscriptions(this.selectedAgrmId)
    })
  },
  methods: {
    fetchStatistics(agrmid) {
      this.loading.statistics = true
      axios.get('statistics', {
        params: {
          agrmid: agrmid
        }
      }).then(promise => {
        this.statistics = promise.data.results
        this.loading.statistics = false
      }).catch(error => {
        console.log(error)
        this.loading.statistics = false
      })
    },
    fetchSubscriptions (agrmid, sort = { column: 'timeto', order: 'descending' }) {
      this.loading.subscriptions = true
      axios.get('subscriptions', {
        params: {
          agrmid: agrmid,
          filterActive: true,
          sortColumn: sort.column,
          sortOrder: sort.order
        }
      }).then(promise => {
        this.subscriptions = promise.data.results
        this.loading.subscriptions = false
      }).catch(error => {
        console.log(error)
        this.loading.subscriptions = false
      })
    },
    selectAgrm(index) {
      this.selectedIndex = index
      this.fetchSubscriptions(this.selectedAgrmId)
      this.fetchStatistics(this.selectedAgrmId)
    },
    subscriptionDeleted() {
      this.fetchSubscriptions(this.selectedAgrmId)
    }
  }
}
</script>
